module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// ./node_modules/sockjs-client/lib/transport/browser/eventsource.js
// module id = 670
// module chunks = 0